module.exports = ".client-form .form-field-outer {\n  width: 280px; }\n\n.client-form .mat-radio-button {\n  margin-right: 12px; }\n"